import { QueryReturnValue } from "@reduxjs/toolkit/dist/query/baseQueryTypes";
import { MaybePromise } from "@reduxjs/toolkit/dist/query/tsHelpers";
import { createApi, FetchBaseQueryError } from "@reduxjs/toolkit/query/react";
import authSlice, { AuthInfo } from "../authSlice";
import { apiBaseQuery, post } from "../helpers";
import { WorkItemFilters } from "./historicalDataApi.query";
import { EmailContentSearchResult } from "./searchApi.models";
import { buildEmailSearchQuery } from "./searchApi.query";

const searchApi = createApi({
  reducerPath: "searchApi",
  tagTypes: ["EmailConversations"],
  baseQuery: apiBaseQuery("/search-api"),
  endpoints: builder => ({
    searchEmails: builder.query<EmailContentSearchResult, Partial<WorkItemFilters>>({
      queryFn: async (filters, api, _, baseQuery) => {
        const userId = (api.getState() as { [authSlice.name]: AuthInfo }).auth.user.id;
        return await baseQuery(post("/emails", buildEmailSearchQuery(filters, userId))) as MaybePromise<QueryReturnValue<EmailContentSearchResult, FetchBaseQueryError, unknown>>;
      },
      providesTags: filters => [{ type: "EmailConversations", id: JSON.stringify(filters) }],
    }),
  }),
});

export const { useSearchEmailsQuery } = searchApi;
export default searchApi;
